import { observable } from 'mobx'
import BaseStore from 'hljd/esm/SearchBar/store'
import Api from '@api/experienceShop'
import { getMomentTime } from '@hlj/hlj-utils'
import { getExportUrl } from '@util'

class Store extends BaseStore {
  $listApi = Api.flowOrderList
  @observable listData = {}

  $getParams = () => {
    let { trade_time, ...rest } = this.$params
    const params = rest

    trade_time = trade_time ? trade_time : this.$searchBar.getFieldsValue('trade_time').trade_time

    if (trade_time && trade_time.length > 0) {
      params.trade_time = `${getMomentTime(
        trade_time,
        0,
        __FMT1__
      )} - ${getMomentTime(trade_time, 1, __FMT1__)}`
    }

    return params
  }

  $extraOp = data => {
    this.listData = data
  }

  exportList = () => {
    const url = getExportUrl(
      '/p/wedding/Admin/APICrmBrokerage/exportFlows',
      this.$getParams()
    )
    window.open(url)
  }
}

export default Store
